import { put, takeLatest } from 'redux-saga/effects';
import hanldeException from './../services/handleException';
import { orderStatus, FulfillOption as FulfillOptionConst } from './../constants';
import { createShipment, deleteOrders, getOrders, editOrder } from './../utils/orders';
import { renderListOrder } from '../services/helper'

const defaultParams = {
    ChannelOrderID: undefined,
    IsDesc: true,
    OrderBy: "OrderDT",
    OrderDateFrom: undefined,
    OrderDateTo: undefined,
    Page: 1,
    PageSize: 50,
    Status: [orderStatus.AWAITING_FINALIZATION, orderStatus.AWAITING_SHIPMENT],
    SelectedIds: [],
}
function* getOrdersSortHandle(data) {
    let params = {
        ...data.payload.params,
        OrderBy: data.payload.column,
    }
    try {
        const json = yield getOrders(params)
        yield put({ type: 'GET_ORDERS_SUCCESS', json })
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'GET_ORDERS_FAILURE', error })
    }
}
function* submit_filter(data) {
    try {
        const json = yield getOrders(data.payload)
        yield put({ type: 'GET_ORDERS_SUCCESS', json })
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'GET_ORDERS_FAILURE', error })

    }
}

function* getOrdersByPageHandle(data) {
    let params = {
        ...data.payload.params,
        Page: data.payload.current_page,
    }
    try {
        const json = yield getOrders(params)
        yield put({ type: 'GET_ORDERS_SUCCESS', json })
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'GET_ORDERS_FAILURE', error })
    }
}
function* getOrdersOnRemoveFilterHandle(data) {
    let params
    if (Number.isInteger(data.payload.value)) {
        params = {
            ...data.payload.params,
            Status: data.payload.params.Status.filter(a => a != data.payload.value),
        }
    }
    if (data.payload.value == 'from') {
        params = {
            ...data.payload.params,
            OrderDateFrom: undefined,
        }
    }
    if (data.payload.value == 'to') {
        params = {
            ...data.payload.params,
            OrderDateTo: undefined,
        }
    }
    if (data.payload.value == 'channel_order_no') {
        params = {
            ...data.payload.params,
            ChannelOrderID: undefined,
        }
    }
    if (data.payload.value == 'channel') {
        params = {
            ...data.payload.params,
            ChannelID: [],
        }
    }
    try {
        const json = yield getOrders(params)
        yield put({ type: 'GET_ORDERS_SUCCESS', json })
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'GET_ORDERS_FAILURE', error })
    }
}

function* getOrdersByNextOrBackHandle(data) {
    let params
    if (data.payload.type === 'back') {
        params = {
            ...data.payload.params,
            Page: data.payload.current_page - 1,
        }
    }
    if (data.payload.type === 'back-head') {
        params = {
            ...data.payload.params,
            Page: 1,
        }
    }
    if (data.payload.type === 'next') {
        params = {
            ...data.payload.params,
            Page: data.payload.current_page + 1,
        }
    }
    if (data.payload.type === 'next-last') {
        params = {
            ...data.payload.params,
            Page: data.payload.pages,
        }
    }
    try {
        const json = yield getOrders(params)
        yield put({ type: 'GET_ORDERS_SUCCESS', json })
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'GET_ORDERS_FAILURE', error })
    }
}

function* getOrdersOnTabHandle(data) {
    let params = {
        ...defaultParams,
        Status: [parseInt(data.payload.tab)],
        PageSize: data.payload.PageSize,
    }
    try {
        const json = yield getOrders(params)
        yield put({ type: 'GET_ORDERS_SUCCESS', json })
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'GET_ORDERS_FAILURE', error })
    }
}

function* resetOrderFilterHandle(data) {
    try {
        const json = yield getOrders({ ...defaultParams, PageSize: data.payload.PageSize })
        yield put({ type: 'GET_ORDERS_SUCCESS', json })
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'GET_ORDERS_FAILURE', error })
    }
}

function* postCreateShipmentHandle(data) {
    try {
        const json = yield createShipment(data.payload)
        if (json.data.code === 10001 || json.data.code === 311503) {
            yield put({ type: 'CREAT_SHIPMENT_SUCCESS', payload: json })
            yield put({ type: 'ON_GET_HEADER_SUMMARY'})
        } else {
            yield put({ type: 'CREAT_SHIPMENT_FAILURE', payload: json })
            hanldeException(json)
        }
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'CREAT_SHIPMENT_FAILURE', payload: error })
    }
}

function* deleteOrdersHandle(data) {
    try {
        const json = yield deleteOrders(data.payload)
        if(json.data.code === 10001) {
            yield put({ type: 'DELETE_ORDER_SUCCESS', json })
        } else {
            yield put({ type: 'DELETE_ORDER_FAILURE', json })
            hanldeException(json)
        }
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'DELETE_ORDER_FAILURE', error })
    }
}

function* getSplitOrderHandle(data) {
    try {
        const json = yield editOrder(data.payload)
        if(json.data.code === 10001) {
            yield put({ type: 'GET_SPLIT_ORDER_SUCCESS', payload: json })
        } else {
            yield put({ type: 'GET_SPLIT_ORDER_FAILURE', payload: json })
            hanldeException(json)

            // reload list order when something goes wrong
            renderListOrder()
        }
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'GET_SPLIT_ORDER_FAILURE', error })

        // reload list order when something goes wrong
        renderListOrder()
    }
}

export function* FilterWatcher() {
    yield takeLatest('ON_SUBMIT', submit_filter)
}

export function* getOrdersSaga() {
    yield takeLatest('ON_SORT', getOrdersSortHandle)
}

export function* getOrdersByPage() {
    yield takeLatest('ON_GET_ORDERS_BY_PAGE', getOrdersByPageHandle)
}
export function* getOrdersByNextOrBack() {
    yield takeLatest('ON_NEXT_OR_BACK_ORDER', getOrdersByNextOrBackHandle)
}
export function* getOrdersOnRemoveFilter() {
    yield takeLatest('ON_REMOVE_FILTER_ORDER', getOrdersOnRemoveFilterHandle)
}
export function* getOrdersOnTab() {
    yield takeLatest('ON_TAB_ORDER', getOrdersOnTabHandle)
}
export function* postCreateShipment() {
    yield takeLatest('ON_CREATE_SHIPMENT', postCreateShipmentHandle)
}
export function* resetOrderFilter() {
    yield takeLatest('ON_RESET_ORDER_FILTER', resetOrderFilterHandle)
}
export function* deleteOrder() {
    yield takeLatest('ON_DELETE_ORDER', deleteOrdersHandle)
}
export function* getSplitOrder() {
    yield takeLatest('GET_SPLIT_ORDER', getSplitOrderHandle)
}



// WEBPACK FOOTER //
// ./src/sagas/orderSaga.js